export default class AdminPaqueteLista {

    constructor() {
        $('#btn-nuevo-paquete').click(function() {
            let form = new AdminPaqueteForm();
            form.nuevo({
                onSuccess: function() {
                    window.location.reload();
                }
            });
        });

        $('.btn-editar').click(function() {
            let form = new AdminPaqueteForm();
            form.editar(this.parentNode.dataset.id, {
                onSuccess: function(response) {
                    window.location.reload();
                }
            });
        });
    }
}